import { Flex, Text, Box, Progress, Avatar } from "@chakra-ui/react";

export const MemberTableColumns = (t: (key: string) => string) => [
  {
    header: t("subscriberManagement.name"),
    accessorKey: "fullname",
    cell: (info: any) => {
      const { fullName, avatar, username } = info.row.original;
      return (
        <Flex align="center" gap={3}>
          <Avatar name={fullName} src={avatar} size="sm" />
          <Box>
            <Text fontWeight="600" fontSize="14px" color="#2F2F34">
              {fullName}
            </Text>
            <Text fontSize="13px" color="gray.500">
              {username ? "@" + username : ""}
            </Text>
          </Box>
        </Flex>
      );
    },
  },
  {
    header: t("subscriberManagement.emailAddress"),
    accessorKey: "email",
    cell: (info: any) => (
      <Text fontSize="14px" color="#2F2F34">
        {info.row.original.email}
      </Text>
    ),
  },
  {
    header: t("subscriberManagement.overallProgress"),
    accessorKey: "progress",
    cell: (info: any) => {
      const { overAllProgress } = info.row.original;
      const roundedProgress = Math.round(overAllProgress);
      return (
        <Flex align="center" gap={3} w="100%">
          <Progress
            value={roundedProgress}
            size="sm"
            colorScheme="blue"
            borderRadius="md"
            flex="1"
          />
          <Text
            fontSize="14px"
            fontWeight="500"
            color="#2F2F34"
            whiteSpace="nowrap"
          >
            {roundedProgress}%
          </Text>
        </Flex>
      );
    },
  },
];
